(() => {
  document.querySelectorAll('[data-ed-duos]').forEach(root => {
    if (root.dataset.edReady) return;
    root.dataset.edReady = 'true';
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-ed-choice]');
      if (!button || !root.contains(button)) return;
      root.querySelectorAll('[data-ed-panel]').forEach(panel => { panel.hidden = panel.dataset.edPanel !== button.dataset.edChoice; });
      root.querySelectorAll('[data-ed-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
    });
  });
})();
